<template>
  <div>

    <exit-permit-form
      v-if="!isPrint && selectedWo"
      :selectedWo="selectedWo"
      @goPrint="goPrint"
    ></exit-permit-form>

    <exit-permit-print
      v-if="isPrint"
      :printData="printData"
      @goBack="isPrint = false"
    ></exit-permit-print>

  </div>
</template>

<script>
  import PageOptions from '@/Options/PageOptions.js';

  import exitPermitForm from './children/exitPermitForm';
  import exitPermitPrint from './children/exitPermitPrint';

  export default {
    data () {
      return { 
        pageOptions : PageOptions,
        isPrint : false,
        printData : null,

        selectedWo : null,
      }
    },
    components : {
      exitPermitForm,
      exitPermitPrint
    },
    mounted () {
      let form_code = this.$route.query.form_code;
      this.selectedWo = (form_code) ? form_code : null;
    },
    methods : {
      goPrint(printData){
        // PageOptions.pageEmpty = true;
        this.printData = printData;
        this.isPrint = true;
        console.log(this.isPrint);
      }
    },
    beforeRouteLeave (to, from, next) {
      PageOptions.pageEmpty = false;
      next();
    },
  }
</script>

<style scoped>
  
</style>